// TODO: migrate over functions from app/javascript/lib/formatters/strings.js here

export function fromRichTextToPlainText(richText: string) {
  if (!richText) return '';

  // Replace HTML tags with a space
  let plainText = richText.replace(/<\/?[^>]+(>|$)/g, ' ');

  // Collapse multiple spaces into a single space
  plainText = plainText.replace(/\s+/g, ' ').trim();

  return plainText;
}

export function capitalize(str: string) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function titleizeFromSnakeCase(string: string) {
  if (!string) return '';
  return string
    .split('_')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
